/**
 * When a current placement gets an end date, we have to know whether the customer takes the candidate over.
 * Placements that already had an end date are not asked again.
 */
export function asksForTakeover(placement, newEndDate) {
    return Boolean(newEndDate) && !(placement && placement.endDate);
}

/**
 * The takeover fields to save along with an edited placement. A placement without end date is running again, so it
 * cannot have been taken over; a placement that was not asked keeps the answer it had.
 */
export function takenOverChange(placementEdit) {
    if (!placementEdit.endDate) {
        return {takenOver: null};
    }

    return typeof placementEdit.takenOver === 'boolean' ? {takenOver: placementEdit.takenOver} : {};
}

/**
 * The candidates with at least one placement that was taken over, collected in one pass so every candidate in the
 * table can be looked up directly.
 */
export function takenOverCandidateIds(placements) {
    return new Set((placements || [])
        .filter(placement => placement.takenOver === true)
        .map(placement => placement.candidateId));
}
